<div class="w-84 h-auto">
    <div class="flex h-11">
      <div class="w-3/5 pl-3">
        <div class="flex">
          <h4 class="max-w-36 truncate overflow-hidden text-lg font-bold cursor-pointer" (click)="openEmployeePreview(data)" title="{{data?.first_name}} {{data?.last_name}}">{{data?.first_name}} {{data?.last_name}}</h4>
          <span class="ml-2 mt-0.5 offline_status" *ngIf="data?.location_data?.is_offline"> {{"text.offline" | translate}}</span>
          <span class="ml-2 mt-0.5 online_status" *ngIf="!data?.location_data?.is_offline"> {{"text.online" | translate}}</span>
        </div>
        <span class="text-sm text-gray-500" *ngIf="data?.designation">{{data?.designation}}</span>
      </div>
      <div class=" w-2/5 text-right pr-3">
        <p class="m-0 mt-4">{{"maps.employee_popup.last_seen_at" | translate}}: {{data?.location_data?.track_time | timeformat}}</p>
      </div>
    </div>
    <div class="flex h-11 mt-1" *ngIf="!data?.hideCreateJob">
      <!-- <a class="w-1/2 flex justify-center items-center text-blue-700 border m-0 border-l-0 cursor-pointer ">{{"maps.employee_popup.assign_job" | translate}}</a> -->
      <a  class="w-full flex justify-center items-center text-blue-700 border border-l-0 border-r-0 m-0 cursor-pointer hover:bg-gray-100" (click)="createNewJob(data)">{{"create.job.text" | translate}}</a>
    </div>
    <div [ngClass]="{'border-t border-gray-200 rounded-none' : data?.hideCreateJob === true,'rounded-lg': !data?.hideCreateJob}" class="bg-white w-full h-auto py-2 flex justify-around text-md">
      <div class="ml-4">
        <p class="text-center text-xl font-bold m-0">{{data?.location_data?.job_count}}</p>
        <p class="my-1 text-center">{{"text.jobs" | translate}}</p>
      </div>
      <div class="ml-4">
        <p class="text-center text-xl font-bold m-0">{{data?.location_data?.battery}}%</p>
        <p class="my-1 text-center">{{"maps.employee_popup.battery" | translate}}</p>
      </div>
      <div class="ml-4">
        <p class="text-center text-xl font-bold m-0">{{data?.location_data?.signal_strength}}%</p>
        <p class="my-1 text-center">{{"maps.employee_popup.network" | translate}}</p>
      </div>
      
    </div>
  </div>